<template>
  <div class="breadContainer">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="item in breadCrumbList"
        :key="item.path"
        :to="{ path: item.path }"
        >{{ item.name }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  name: 'breadTitle',
  props: {
      breadCrumbList: Array
  }
}
</script>
<style scoped>
.breadContainer {
  margin: 0;
  min-width: 0;
}
</style>
